package nl.staartvin.solarpower.data.currentuvindex

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

// Wire shape for https://currentuvindex.com/api/v1/uvi?latitude=&longitude=
// Confirmed live during session bootstrap. The handoff doc guessed the array key
// was "hourly_forecast" — it's actually "forecast".

@Serializable
internal data class UviResponseDto(
    val ok: Boolean,
    val latitude: Double,
    val longitude: Double,
    val now: SampleDto,
    val forecast: List<SampleDto>,
    @SerialName("history") val history: List<SampleDto>? = null,
)

@Serializable
internal data class SampleDto(
    val time: String,  // ISO-8601 UTC, e.g. "2026-06-20T13:00:00Z"
    val uvi: Double,
)
